<header>
  <h1>
    Regular Employment Insurance (EI) beneficiaries in Canada (2019 - 2021)
  </h1>
</header>

<style>
  header {
    margin-top: 40px;
    margin-bottom: 30px;
    max-width: 600px;
  }

  h1 {
    font-family: 'Merriweather';
    font-size: 22px;
    line-height: 30px;
    text-align: center;
  }
</style>
